import { useQuery } from "@tanstack/react-query";
import { api } from "lib/api";

function contactoJefesPublicosKey() {
  return ["main", "contacto", "jefes"];
}

export function useMainContactoJefesPublicos(enabled = true) {
  return useQuery({
    queryKey: contactoJefesPublicosKey(),
    queryFn: () => api("/public/actividades/contacto"),
    enabled,
    staleTime: 60_000,
  });
}
